import * as React from 'react';
import { Logging } from '@vcd-ecm-ui/Common';
import CustomerContactsProps from './CustomerContactsProps.interface';
import '../../customer-info.scss';
import Contacts from './Grid/Contacts';

const CustomerContacts = ({
  customer,
  hasParentCustomer,
  gatewayEndPoint,
}: CustomerContactsProps): JSX.Element => {
  Logging.Debug('Customer Contacts');

  return (
    <div className="contactsContainer">
      <Contacts
        customerUuid={customer.uuid}
        gatewayEndPoint={gatewayEndPoint}
        contacts={customer.contacts}
        hasParent={hasParentCustomer}
      />
    </div>
  );
};

export default CustomerContacts;
